import PageHeader from "@/components/PageHeader";
import Manifesto from "@/components/Manifesto";
import Schedule from "@/components/Schedule";
import TrafficLightStatus from "@/components/TrafficLightStatus";
import HolidayDates from "@/components/HolidayDates";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function TimesPage() {
  useSeo({
    title: "Times — Hours & Weather | Cool Runnings Cape Town",
    description:
      "Opening hours and the live weather: Mon–Fri 11h00–18h00, weekends & school holidays 09h00–18h00. Closed only when it rains.",
    keywords:
      "Cool Runnings opening hours, toboggan park hours Cape Town, Cool Runnings weather, when is Cool Runnings open, family outing hours Cape Town",
    image: "/og/times.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Times"
        eyebrow="Hours, calendar & weather"
        title="TIMES & LIVE WEATHER"
        subline="Today's status and the live weather — free entry, free parking, closed only when it rains."
        image="/park-bar.jpg"
      />

      <section className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="visit-status-section">
        <TrafficLightStatus />
      </section>
      <Schedule />
      <HolidayDates />
      <Manifesto />
      <CtaBand />
    </>
  );
}
